export const sendClientYaMetrikaGoal = (counterId: number, goal: string) => {
  const ym = (window as any)['ym'];
  const newYaMetrikaKey = `yaCounter${counterId}`;
  const newYm = (window as any)[newYaMetrikaKey];

  if (newYm) {
    newYm.reachGoal(goal);
    return;
  }

  if (ym) {
    ym(counterId, 'reachGoal', goal);
    return;
  }

  console.error('Yandex Metrika not found!');
};

export const initYaMetrika = (counterId: number) => {
  const ym = (window as any)['ym'];

  if (ym) {
    ym(counterId, 'init', {
      clickmap: false,
      trackLinks: false,
      accurateTrackBounce: false,
      webvisor: false,
    });
    return;
  }

  console.error('Yandex Metrika not found!');
};
